import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

function Login() {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    navigate('/');
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: `linear-gradient(rgba(0, 0, 0, 0.75), rgba(10, 10, 10, 0.95)), url('https://images.unsplash.com/photo-1542314831-c53cd3816002?auto=format&fit=crop&w=1920&q=80') center/cover no-repeat fixed`, padding: '20px', fontFamily: 'Georgia, serif' }}>
      <div style={{ background: 'linear-gradient(135deg, #1a1a1a, #0a0a0a)', padding: '50px 40px', borderRadius: '20px', width: '100%', maxWidth: '450px', border: '1px solid rgba(212,175,55,0.4)', boxShadow: '0 25px 50px rgba(0,0,0,0.8), 0 0 40px rgba(212,175,55,0.2)', position: 'relative' }}>
        
        <div style={{ textAlign: 'center', marginBottom: '35px' }}>
          <img src="/logo.png" alt="Visawa Logo" style={{ width: '90px', marginBottom: '15px', filter: 'drop-shadow(0 0 15px rgba(212,175,55,0.5))' }} />
          <h2 style={{ color: '#d4af37', margin: '0 0 5px 0', fontSize: '2rem', textTransform: 'uppercase', letterSpacing: '3px' }}>Welcome Back</h2>
          <p style={{ color: '#aaa', margin: 0, fontSize: '0.9rem', letterSpacing: '1px', fontFamily: 'sans-serif' }}>Login to your VIP account</p>
        </div>

        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '20px', fontFamily: 'sans-serif' }}>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <label style={{ color: '#ccc', fontSize: '0.85rem', marginBottom: '8px', textTransform: 'uppercase', letterSpacing: '1px', fontWeight: 'bold' }}>Certificate ID / Admin Username</label>
            <input
              type="text"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              style={{ width: '100%', padding: '15px', background: 'rgba(0,0,0,0.5)', border: '1px solid rgba(212,175,55,0.3)', borderRadius: '8px', color: '#fff', fontSize: '1rem', outline: 'none', boxSizing: 'border-box' }}
              placeholder="e.g. VSW-123456"
            />
          </div>
          
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <label style={{ color: '#ccc', fontSize: '0.85rem', marginBottom: '8px', textTransform: 'uppercase', letterSpacing: '1px', fontWeight: 'bold' }}>Password</label>
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
              style={{ width: '100%', padding: '15px', background: 'rgba(0,0,0,0.5)', border: '1px solid rgba(212,175,55,0.3)', borderRadius: '8px', color: '#fff', fontSize: '1rem', outline: 'none', boxSizing: 'border-box' }}
              placeholder="Enter your password"
            />
          </div>

          <button type="submit" disabled={loading} style={{ background: 'linear-gradient(135deg, #d4af37, #b5952f)', color: '#111', padding: '16px', border: 'none', borderRadius: '8px', fontSize: '1.05rem', fontWeight: 'bold', textTransform: 'uppercase', letterSpacing: '2px', cursor: 'pointer', marginTop: '10px', boxShadow: '0 5px 15px rgba(212,175,55,0.3)' }}>
            {loading ? 'Authenticating...' : 'Secure Login'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default Login;
